import { Group, Stack, Text, useMantineTheme } from "@mantine/core"
import { IconBriefcase, IconMail, IconUsers } from "@tabler/icons-react"

import { LibraryResponses } from "@tfg/types/endpoints/library"

type ContactCardProps = {
  contact: LibraryResponses.SupplierDetails
}

export function ContactCard({ contact }: ContactCardProps) {
  const { colors } = useMantineTheme()

  return (
    <>
      <Group wrap="nowrap">
        <Stack>
          <Group>
            <IconBriefcase color={colors.beige[9]} size={16} />
            <Text
              fz="lg"
              fw={700}
              style={{
                overflow: "",
                wordBreak: "break-all",
              }}
            >
              {contact.company.length > 0 ? contact.company : "N/A"}
            </Text>
          </Group>
          <Group>
            <IconUsers color={colors.beige[9]} size={16} />
            <Text
              fz="sm"
              fw={500}
              style={{
                overflow: "",
                wordBreak: "break-all",
              }}
            >
              {contact.name.length > 0 ? contact.name : "N/A"}
            </Text>
          </Group>
          <Group>
            <IconMail color={colors.beige[9]} size={16} />
            <Text
              fz="sm"
              fw={500}
              style={{
                overflow: "",
                wordBreak: "break-all",
              }}
            >
              {contact.email}
            </Text>
          </Group>
        </Stack>
      </Group>
    </>
  )
}
